var data = {
	"body": "<path d=\"M29.2 26.72a12.07 12.07 0 0 1-6.3-22.28A13.68 13.68 0 0 0 19.49 4a14 14 0 0 0 0 28a13.82 13.82 0 0 0 10.9-5.34a11.71 11.71 0 0 1-1.19.06z\" class=\"clr-i-solid clr-i-solid-path-1\" fill=\"currentColor\"/>",
	"width": 36,
	"height": 36
};
exports.__esModule = true;
exports.default = data;
